export default __webpack_public_path__ + "static/media/circle-exclamation-solid.6f6af163.svg";